import React from 'react';
import TouchableOpacity from "./TouchableOpacity";
import View from "./View";
import {ColorClear} from "../../../styles/Colors";
import {HeightElementMinimum, SpaceXSmall} from "../../../res/Spacing";
import {RadiusView} from "../../../res/Radius";
import AppIcon from "./AppIcon";

export default class AppIconButton extends React.PureComponent {

  onClick = (event) => {
    this.props.onClick(event);
  };

  render() {
    let color = this.props.color;
    let icon = this.props.icon;
    let size = this.props.size;
    let sizePx = this.props.sizePx;
    let bgColor = this.props.bgColor;
    if (bgColor === undefined) {
      bgColor = ColorClear;
    }
    let style = this.props.style;
    let disabled = this.props.disabled;

    let opacity = 1;
    if (disabled) {
      opacity = 0.3;
    }

    let view = <View style={{alignItems: 'center', justifyContent: 'center',
      backgroundColor: bgColor,
      borderRadius: RadiusView,
      padding: SpaceXSmall,
      opacity: opacity,
      minWidth: HeightElementMinimum,
      minHeight: HeightElementMinimum,
      ...style}}>
      <AppIcon icon={icon} size={size} color={color} style={sizePx ? {width: sizePx, height: sizePx} : null}/>
    </View>;
    return (
      disabled ?
        <View>{view}</View> :
          <TouchableOpacity onClick={this.onClick}>
            {view}
          </TouchableOpacity>
    );
  }
}

